import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const VirtualConnectionDownstreamSheetsQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamSheetsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
